import { defineMessages } from 'react-intl';

/** Streaming → Accelerator (design streaming-sections d1, d2). */
export const acceleratorMessages = defineMessages({
  emptyTitle: {
    id: 'app.sml.streaming.accelerator.empty.title',
    defaultMessage: 'See your TuneCore Accelerator streams',
  },
  emptyText: {
    id: 'app.sml.streaming.accelerator.empty.text',
    defaultMessage:
      'Accelerator is a TuneCore program. Connect TuneCore, and MUSIC24 shows its streams for each month.',
  },
  monthLine: {
    id: 'app.sml.streaming.accelerator.monthLine',
    defaultMessage: 'Accelerator is a TuneCore program. TuneCore counts its streams per month.',
  },
  fromAccelerator: { id: 'app.sml.streaming.accelerator.from', defaultMessage: 'From Accelerator' },
  shareOfAll: { id: 'app.sml.streaming.accelerator.shareOfAll', defaultMessage: 'Share of all streams' },
  shareOfAllSub: { id: 'app.sml.streaming.accelerator.shareOfAll.sub', defaultMessage: 'of {count}' },
  monthSub: { id: 'app.sml.streaming.accelerator.month.sub', defaultMessage: '{share} of {count}' },
  tracksCount: { id: 'app.sml.streaming.accelerator.tracksCount', defaultMessage: 'Tracks in Accelerator' },
  perMonth: { id: 'app.sml.streaming.accelerator.perMonth', defaultMessage: 'Streams per month' },
  otherStreams: { id: 'app.sml.streaming.accelerator.otherStreams', defaultMessage: 'All other streams' },
  barsNote: {
    id: 'app.sml.streaming.accelerator.barsNote',
    defaultMessage: "The number on each bar is the share of the month's streams that came from Accelerator.",
  },
  tracksTitle: { id: 'app.sml.streaming.accelerator.tracks', defaultMessage: 'Tracks in Accelerator' },
  trackColumn: { id: 'app.sml.streaming.accelerator.column.track', defaultMessage: 'Track' },
  allColumn: { id: 'app.sml.streaming.accelerator.column.all', defaultMessage: 'All streams' },
  shareColumn: { id: 'app.sml.streaming.accelerator.column.share', defaultMessage: 'Share' },
  changeColumn: { id: 'app.sml.streaming.accelerator.column.change', defaultMessage: 'Change' },
  tracksNote: {
    id: 'app.sml.streaming.accelerator.tracksNote',
    defaultMessage:
      'As reported by TuneCore. Change is against the month before. Accelerator streams are part of all streams; they are not extra streams.',
  },
  offTitle: {
    id: 'app.sml.streaming.accelerator.off.title',
    defaultMessage: 'No Accelerator streams in the last 12 months',
  },
  offText: {
    id: 'app.sml.streaming.accelerator.off.text',
    defaultMessage:
      'TuneCore reports 0 Accelerator streams for every month. Accelerator is probably not on for this TuneCore account. You turn it on in TuneCore.',
  },
  noDataTitle: {
    id: 'app.sml.streaming.accelerator.noData.title',
    defaultMessage: 'No Accelerator numbers for this period yet',
  },
  noDataText: {
    id: 'app.sml.streaming.accelerator.noData.text',
    defaultMessage:
      'TuneCore sent no Accelerator month for this period. MUSIC24 shows the numbers after TuneCore reports them.',
  },
  openTuneCore: { id: 'app.sml.streaming.accelerator.openTuneCore', defaultMessage: 'Open TuneCore' },
});
